import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

const SUPPORTED = LANGUAGES.map((l) => l.code);

// Keeps <html lang>, <title>, meta description and hreflang alternates in sync
// with the active language. Renders nothing; changes only document head.
// No routing/functionality/design changes.
function setMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setHreflang() {
  const href = window.location.origin + window.location.pathname;
  [...SUPPORTED, "x-default"].forEach((code) => {
    let el = document.head.querySelector(`link[rel="alternate"][hreflang="${code}"]`);
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "alternate");
      el.setAttribute("hreflang", code);
      document.head.appendChild(el);
    }
    el.setAttribute("href", href);
  });
}

export function SeoManager() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const apply = () => {
      const lang = i18n.resolvedLanguage || "sv";
      document.documentElement.setAttribute("lang", lang);
      document.title = t("seo.title");
      setMeta("description", t("seo.description"));
      setHreflang();
    };
    apply();
    i18n.on("languageChanged", apply);
    return () => i18n.off("languageChanged", apply);
  }, [t, i18n]);

  return null;
}
